module.exports = __webpack_public_path__ + "static/media/calendar_ionicon.9fea16aa.svg";